// Which campaign this device is working in.
//
// ⚠⚠ PER DEVICE, NOT PER ACCOUNT, AND THAT IS NOT LAZINESS. A game master preparing next week's session on a
// laptop and running tonight's game off the table television are doing two different things, and the second
// must not follow the first. It is the same reasoning as the rail's remembered tab — see `rail-layout.ts`.
//
// ⚠ IT IS A HINT, NEVER AN AUTHORITY. Everything this points at is checked against what the database actually
// returns: a campaign deleted on another machine, or one belonging to an account that has since signed out,
// leaves a dead id here. The caller must fall back to "no campaign" rather than trusting the string.
//
// ⚠ KEYED BY USER. Two accounts on one browser — the owner and a test login — must not inherit each other's
// campaign, which is exactly the sort of thing that goes unnoticed until something is filed in the wrong place.

const KEY = "compendium.campaign";

type Blob = Record<string, string>;

function read(): Blob {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const v: unknown = JSON.parse(raw);
    // Anything but an object of strings is somebody else's data or a corrupted write. Start clean.
    if (!v || typeof v !== "object" || Array.isArray(v)) return {};
    const out: Blob = {};
    for (const [k, val] of Object.entries(v as Record<string, unknown>)) {
      if (typeof val === "string") out[k] = val;
    }
    return out;
  } catch {
    // ⚠ localStorage THROWS where site data is blocked, not just returns null. Unguarded, this takes the app
    // down on the first render rather than costing a convenience.
    return {};
  }
}

export function loadCurrentCampaign(userId: string): string | null {
  return read()[userId] ?? null;
}

export function saveCurrentCampaign(userId: string, campaignId: string | null): void {
  try {
    const blob = read();
    if (campaignId) blob[userId] = campaignId;
    else delete blob[userId];
    localStorage.setItem(KEY, JSON.stringify(blob));
  } catch { /* a preference, not data — losing it costs one click */ }
}
